var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('button', {
    staticClass: "button",
    class: _vm.customClass,
    attrs: {
      "type": _vm.type,
      "disabled": _vm.isDisabled,
      "aria-label": _vm.translations[_vm.keyTranslation] || _vm.text || ''
    },
    on: {
      "click": _vm.clickEvent
    }
  }, [_vm._t("left-icon"), _vm._v("\n  " + _vm._s(_vm.translations[_vm.keyTranslation] || _vm.text || '') + "\n  "), _vm._t("right-icon")], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }